<template>
  <div>
    <div id="table">
      <v-chip small :color="getColor()" dark style="z-index: 3">
        <v-icon small class="ma-2" left>{{mdiGoogleClassroom}}</v-icon>
          Room <v-chip class="pa-1 ma-1" dark label x-small >{{tableId}}</v-chip>
      </v-chip>

      <div v-if="itsChristmas()" class="garland" v-bind:style="{ backgroundImage: 'url(' + getGarlandImg() + ')' }" contain></div>

      <v-container id="board">
          <v-row justify="center" no-gutters>
            <v-col align="center" justify="center" :cols="getColsNumber()" class="d-flex child-flex" v-for="item in table" :key="getKey(item)">
              <TableCard :maxWidth="getMaxWith()" :item="item" :socketId="socketId" :showCards="showTableCards" :userId="userId" :tableId="tableId" :mode="mode"/>
            </v-col>
          </v-row>
      </v-container> 
      
      <Results :mode="mode" :table="table" :showTableCards="showTableCards" :tableId="tableId" />

      <ShowTableBtn :connected="this.$socket.connected" :tableId="tableId" :round="round" :showTableCards="showTableCards" />
      <ChangeModeBtn :connected="this.$socket.connected" :tableId="tableId"/>

      <v-container v-if="!showTableCards" id="cards">
        <v-container v-if="this.$socket.connected" :id="mode === 'fibonacci' ? '' : 'tshirtcards'">
          <v-row v-if="showReaperSentece" style="margin-bottom: 5px">
            <v-col class="col-1 offset-4" style="padding: 5px">
              <v-img style="float: right; margin-top: 10px;" max-width=30 v-bind:src="getReaperImage()"></v-img>
            </v-col>
            <v-col class="col-3" style="padding: 5px">
              <div class="bubble bubble-bottom-left">{{reaperSentence}}</div>
            </v-col>
          </v-row>

          <v-row row no-gutters v-if="this.hasEveryoneVoted()">
            <v-col cols="9" offset-md="1">
              <v-progress-linear stream v-model="value" :buffer-value="0" style="margin-top: 5px"></v-progress-linear>
            </v-col>
            <v-col cols="2">
              <v-icon large color="primary" style="margin-top: -10px">{{mdiEyeOutline}}</v-icon>
              <v-icon large color="primary" style="margin-top: -10px">{{mdiCards}}</v-icon>
            </v-col>
          </v-row>
          <v-row row v-if="mode === 'tshirt'" no-gutters>
            <v-col v-for="(item, i) in cards" :key="'C'+i">
              <TshirtCard :item="item" :socketId="socketId" />         
            </v-col>
          </v-row>
          <v-row row v-else-if="mode === 'thumbs'" no-gutters>
            <v-col v-for="(item, i) in cards" :key="'C'+i" >
              <ThumbsCard :item="item" :socketId="socketId" />            
            </v-col>
          </v-row>
          <!-- <v-row row v-else no-gutters style="overflow-x: auto; flex-wrap: nowrap;"> -->
          <v-row row v-else no-gutters>
            <v-col :cols="mobile ? 2 : 0" v-for="(item, i) in cards" :key="'C'+i">
              <FibonacciCard :item="item" :socketId="socketId" />  
            </v-col>
          </v-row>
        </v-container>
        <div v-if="itsChristmas()" class="lights" v-bind:style="{ backgroundImage: 'url(' + getLightsImg() + ')' }" contain></div>
        <div class="eggs" v-if="itsEaster()" v-bind:style="{ backgroundImage: 'url(' + getEggsImg() + ')' }" contain ></div>
      </v-container> 

      <div v-if="!this.$socket.connected">
        <ProgressBar />
      </div>
      
    </div>

    <Chat v-if="this.$store.state.showChat" :messages="messages" :userId="userId"/>
    <Settings v-if="this.$store.state.showSettings"/>
  </div>
</template>

<script>
import TshirtCard from '../components/cards/TshirtCard'
import ThumbsCard from '../components/cards/ThumbsCard'
import FibonacciCard from '../components/cards/FibonacciCard'
import TableCard from '../components/table/TableCard'
import ShowTableBtn from '../components/buttons/ShowTableBtn'
import ChangeModeBtn from '../components/buttons/ChangeModeBtn'
import ProgressBar from '../components/table/ProgressBar'
import Chat from '../components/table/Chat'
import Settings from '../components/table/Settings'
import Results from '../components/table/Results'
import { mdiGoogleClassroom, mdiEyeOutline, mdiCards, mdiClose, mdiPlay } from '@mdi/js'
import JSConfetti from 'js-confetti'

var userId = Math.trunc(Math.random() * 1000000000)
var initialMode = 'fibonacci'

export default {
  name: 'search',
  data () {
    return {
      mode: initialMode,
      cards: this.getCards(initialMode),
      table: {},
      showCards: true,
      showTableCards: false,
      socketId: undefined,
      active: false,
      round: 0,
      userId: userId,
      mdiGoogleClassroom,
      mdiCards,
      mdiPlay,
      mdiEyeOutline,
      mdiClose,
      value: 0,
      interval: 0,
      messages: [],
      reaperSentence: "I need to choose someone",
      reaperSentences: [
        "I need to choose someone",
        "Let's see",
        "What if you",
        "Maybe you",
        "Too much choice",
        "mmm...",
        "And if i will choose you?",
        "You sounds good to me"
      ],
      showReaperSentece: false
    }
  },
  watch: {
    value (val) {
      if (val < 100) return
      clearInterval(this.interval)

      this.value = 0
      this.$socket.emit('showcards', { tableId: this.tableId, show: true, round: this.round })
    },
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  mounted: function () {
    this.$socket.emit('imnew', { userId: userId, tableId: this.tableId })
    this.$socket.emit('allMessages', this.tableId)
    this.$socket.open()
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    }
  },
  sockets: {
    imnew (user) {
      this.socketId = user.socketId
      this.$socket.emit('vote', { name: 'unvoted', value: null, tableId: this.tableId, userId: userId, socketId: this.socketId })
    },
    update (table) {
      this.changeMode(table.mode)
      this.table = table.guests
      this.showTableCards = table.show

      this.round = table.round

      this.$store.commit('setAvatarStyle', table.avatarStyle)
      this.$store.commit('updateUsers', Object.values(table.guests).map(it => it.userId))
      this.$store.commit('setAvatarBackground', table.avatarBackground)
      this.$store.commit('setHolidaysMode', table.holidaysMode)

      this.checkEveryoneVoted()
    },
    showcards (show) {
      this.showTableCards = show
      this.checkConfetti()
    },
    allMessages (messages) {
      this.messages = messages

      if(!this.$store.state.showChat && !!messages && messages.length > 0)
        this.$store.commit('increaseUnreadMessages')
    },
    victim (name) {
      this.$store.commit("setServerVictim", name)
      this.showReaperSentece = true;

      let reaperMessagesInterval = setInterval(() => {
        this.reaperSentence = this.reaperSentences[Math.floor(Math.random() * this.reaperSentences.length)];
      }, 1000)

      let timesRun = 0;
      let interval = setInterval(() => {
        timesRun += 1;
        if(timesRun === 20) {
         clearInterval(interval);
         clearInterval(reaperMessagesInterval);
         this.showReaperSentece = false

         this.$store.commit("syncVictim")
         new JSConfetti().addConfetti({
          emojis: ['⚰️', '💀', '🔪'],
          emojiSize: 100,
         })
        }
        else
          this.$store.commit("chooseRandomVictim")
      }, 200)
    },
    resetVictim () {
      this.$store.commit('resetVictim')
    }
  },
  props: {
    tableId: String
  },
  components: {
    TshirtCard,
    ThumbsCard,
    FibonacciCard,
    TableCard,
    ShowTableBtn,
    ChangeModeBtn,
    ProgressBar,
    Results,
    Chat,
    Settings
  },
  methods: {
    stopCountdown () {
      clearInterval(this.interval)
      this.value = 0
    },
    startBuffer () {
      clearInterval(this.interval)

      this.interval = setInterval(() => {
        if(!this.hasEveryoneVoted())
          this.stopCountdown()
        else
          this.value += 3
      }, 100)
    },
    changeMode: function (mode) {
      this.mode = mode
      this.cards = this.getCards(mode)
    },
    getGarlandImg: function () {
      return require('@/assets/garland.png')
    },
    getEggsImg: function () {
      return require('@/assets/eggs.png')
    },
    getLightsImg: function () {
      return require('@/assets/lights.png')
    },
    checkConfetti: function () {
      const validVotes = Object.values(this.table).map(it => it.value).filter(it => !!it)
      if(this.showTableCards === true
          && new Set(validVotes).size === 1
          && validVotes.length > 1)
        this.confetti()
      
    },
    hasEveryoneVoted: function () {
      const dones = Object.values(this.table).map(it => it.done).filter(it => !!it)
      if(dones.length === Object.keys(this.table).length)
        return true
      return false
    },
    checkEveryoneVoted: function () {
      if(this.hasEveryoneVoted())
        this.startBuffer()
    },
    confetti: function () {
      new JSConfetti().addConfetti()
    },
    getMaxWith: function () {
      const guestNumber = Object.keys(this.table).length
      if(guestNumber <= 6)
        return '300px'
      return '150px'
    },
    getColsNumber: function () {
      const guestNumber = Object.keys(this.table).length
      if(guestNumber <= 5)
        return 0
      if(guestNumber <= 12)
        return 2

      if(this.$vuetify.breakpoint.name === 'xs')
        return 2
      return 1
    },
    getKey: function (item) {
      if(item !== undefined)
        return item.userId
      return Math.trunc(Math.random() * 100)
    },
    getCards: function (newMode) {
      switch (newMode) {
        case 'tshirt':
          return this.tshirtCard()
        case 'thumbs':
          return this.thumbsCard()
        default:
          return this.fibonacciCard()
      }
    },
    fibonacciCard: function () {
      return [
        { name: '1', value: 1, tableId: this.tableId, userId: userId },
        { name: '2', value: 2, tableId: this.tableId, userId: userId },
        { name: '3', value: 3, tableId: this.tableId, userId: userId },
        { name: '5', value: 5, tableId: this.tableId, userId: userId },
        { name: '8', value: 8, tableId: this.tableId, userId: userId },
        { name: '13', value: 13, tableId: this.tableId, userId: userId },
        { name: '20', value: 20, tableId: this.tableId, userId: userId },
        { name: '40', value: 40, tableId: this.tableId, userId: userId },
        { name: '100', value: 100, tableId: this.tableId, userId: userId },
        { name: 'infinite', value: 0, tableId: this.tableId, userId: userId },
        { name: 'question', value: 0, tableId: this.tableId, userId: userId },
        { name: 'unvoted', value: null, tableId: this.tableId, userId: userId }
      ]
    },
    tshirtCard: function () {
      return [
        { name: 'xs', value: 1, tableId: this.tableId, userId: userId },
        { name: 's', value: 2, tableId: this.tableId, userId: userId },
        { name: 'm', value: 3, tableId: this.tableId, userId: userId },
        { name: 'l', value: 4, tableId: this.tableId, userId: userId },
        { name: 'xl', value: 5, tableId: this.tableId, userId: userId },
        { name: 'unvoted', value: null, tableId: this.tableId, userId: userId }
      ]
    },
    thumbsCard: function () {
      return [
        { name: 'up', value: 1, tableId: this.tableId, userId: userId },
        { name: 'middle-up', value: 2, tableId: this.tableId, userId: userId },
        { name: 'middle', value: 3, tableId: this.tableId, userId: userId },
        { name: 'middle-down', value: 4, tableId: this.tableId, userId: userId },
        { name: 'down', value: 5, tableId: this.tableId, userId: userId },
        { name: 'unvoted', value: null, tableId: this.tableId, userId: userId }
      ]
    },
    getReaperImage: function () {
      return require('@/assets/reaper.svg');
    },
    itsChristmas: function () {
      return this.$store.state.holidaysMode === 'christmas'
    },
    itsEaster: function () {
      return this.$store.state.holidaysMode === 'easter'
    },
    getColor: function() {
      if(this.itsChristmas())
        return "#F44336"
      else if (this.itsEaster())
        return "#FFC107"
      return "#4676be"
    }
  }
}
</script>


<style scoped>
 #cards {
  min-height: 100px;
  position: fixed; bottom: 0; left: 0; right: 0; display: flex;
  background-color: rgba(245, 245, 245, 0.75); 
  border-radius: 40px 40px 0 0;
}

#tshirtcards {
  max-width: 560px;
}

.bubble {
  position: relative;
  font-family: sans-serif;
  font-size: 15px;
  line-height: px;
  background: #fff;
  border-radius: 40px;
  padding: 10px;
  text-align: center;
  color: #000;
}

.bubble-bottom-left:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 24px solid #fff;
  border-right: 12px solid transparent;
  border-top: 12px solid #fff;
  border-bottom: 20px solid transparent;
  left: -12px;
  bottom: 10px;
  transform: rotate(180deg);
}

.garland {
  position: absolute;
  margin-top: -38px;
  margin-left: -12px;
  height: 10%;
  width: 100%;
  background-repeat: repeat-x;
  background-size: 230px;
}

.eggs {
  position: absolute;
  margin-top: 11%;
  margin-left: -200px;
  width: 150%;
  height: 100px;
  background-repeat: repeat-x;
  background-size: 230px;
}

.lights {
  position: absolute;
  margin-left: 18px;
  margin-top: -19px;
  height: 15%;
  width: 95%;
  background-repeat: repeat-x;
  background-size: 80px;
  z-index: -1;
}

::-webkit-scrollbar {
    display: none;
}
</style>
